import styles from './RiveDropDownDivider.module.css';

export default function RiveDropDownDivider() {
  return <hr className={styles.RiveDropDownDivider} />;
}
